module.exports = bamShared.disneyOneIdWrapper;